import { Input, Directive, Component } from '@angular/core';

@Component({ template: '' })
export abstract class ActionSpecificSettingsComponent {
   @Input()
   public brickInstanceId: string;

   @Input()
   public toolbarId: string;

   @Input()
   public actionId: string;
}
